/** An HTTP error from the API, with FastAPI's `detail` when there is one. */
export class ApiError extends Error {
  readonly status: number;
  readonly detail: unknown;

  constructor(status: number, detail: unknown, message?: string) {
    super(message ?? describe(status, detail));
    this.name = "ApiError";
    this.status = status;
    this.detail = detail;
  }
}

function describe(status: number, detail: unknown): string {
  if (typeof detail === "string") return detail;
  // structured refusals, e.g. {code: "subscription_inactive", message: "..."}
  if (detail && typeof detail === "object" && typeof (detail as { message?: unknown }).message === "string")
    return (detail as { message: string }).message;
  // FastAPI validation errors: [{loc, msg, type}, ...]
  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0] as { msg?: unknown; loc?: unknown };
    const where = Array.isArray(first.loc) ? first.loc.slice(1).join(".") : "";
    if (typeof first.msg === "string") return where ? `${where}: ${first.msg}` : first.msg;
  }
  if (status === 0) return "Can't reach the server";
  return `Request failed (${status})`;
}

export async function errorFrom(res: Response): Promise<ApiError> {
  let detail: unknown;
  try {
    const body = (await res.json()) as { detail?: unknown };
    detail = body?.detail ?? body;
  } catch {
    detail = res.statusText || null;
  }
  return new ApiError(res.status, detail);
}
